








import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  computed: {}
})

export default class NotFound extends Vue {}
